import * as Sentry from "@sentry/react";
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx'
import './index.css'
import './styles/tour.css'

Sentry.init({
  dsn: "https://43e9b2424ad5027cbe5481590ac4ab80@o4511171708125184.ingest.de.sentry.io/4511171713564752",
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 1.0,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
});

// Only register SW in web/browser context — skip in Capacitor native WebViews
if (typeof window !== 'undefined' && !('Capacitor' in window)) {
  registerSW({ immediate: true });
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
